<template>
    <div class="relative">
        <div class="splide" id="dashboard-slide-info">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide cursor-pointer"
                        v-for="(dashboard, k) in arrDashboard"
                        :key="k"
                        @click="clickDashboard(dashboard)">
                        
                        <div v-if="dashboard.line1 != null || dashboard.line2 != null" class="absolute top-0 bottom-0 right-0 mx-auto flex items-center w-full">
                            <div class="splide__detail">
                                <div class="font-bold text-16 md:text-24 text-white mb-2" v-html="dashboard.line1"></div>
                                <div class="font-regular text-14 md:text-16 text-white" v-html="dashboard.line2"></div>
                            </div>
                        </div>
                        <div class="splide__image w-full" :style="{'background-image': `url('${dashboard.imageUrl}')`}"></div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="absolute top-0 left-0 h-full flex md:hidden">
            <img class="my-auto h-14" src="@/assets/dashboard/btn-prev.svg" @click="btnPrev()" />
        </div>
        <div class="absolute top-0 right-0 h-full flex md:hidden">
            <img class="my-auto h-14" src="@/assets/dashboard/btn-next.svg" @click="btnNext()" />
        </div>
    </div>
</template>
<script>
//library
import Splide from '@splidejs/splide'; //https://splidejs.com/
//helper
// import Util from '@/helper/Utility.js';
import Locale from "@/helper/locale/Locale.js";
//service
import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";

/**
 * @event onLoaded
 */
export default {
    props: {
        apiConfig: { type: String, required: true },
    },
    data: function() {
        return {
            arrDashboard: [],
            slider: null,
            currentSliderIndex: 0,
        };
    },
    created: function() {
        this.getDashboard();
    },
    methods: {

        getDashboard: function() {
            var configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            var params = configBuilder.create().getParams();
            BzbsDashboard.apiGetSubDashboard(params, this.apiConfig).subscribe((data) => {
                this.arrDashboard = data;
                this.setSlider();

                this.$emit('onLoaded');
            }, (err) => {
                this.$emit('onLoaded');
                console.log(err);
            });
        },
        clickDashboard: function(dashboard) {
            if (dashboard.type == 'link') {
                window.open(dashboard.url, '_blank');
            } else if (dashboard.type == 'campaign') {
                this.$router.push('/product/' + dashboard.id);
            } else if (dashboard.type == 'bzbs_cat' || dashboard.type == 'cat') {
                if (dashboard.cat == "rewards") {
                    this.$router.push('/reward');
                } else {
                    this.$router.push('/home/' + dashboard.cat);
                }
            }
        },
        setSlider: function() {
            this.$nextTick(() => {
                this.slider = new Splide('#dashboard-slide-info', {
                    type: 'loop',
                    arrows: false,
                    lazyLoad: true,
                }).mount();
                this.slider.on('move', (newIndex) => {
                    this.currentSliderIndex = newIndex;
                });
            });
        },

        btnNext: function() {
            let next = this.currentSliderIndex + 1;
            this.slider.go(next);
        },
        btnPrev: function() {
            let prev = this.currentSliderIndex - 1;
            this.slider.go(prev);
        },
    },
}
</script>
<style lang="scss">
  @import "@/style/base/image.scss";

    #dashboard-slide-info {
        position: relative;
       

        .splide__image{
            @include boxRatio($ratio: 66.66%);
        }

        .splide__detail{
            padding: 20px 40px 20px 20px;
            height: auto;
            background-color: #d62300;
            margin-left: auto;
            max-width: 80%;
            z-index: 1;

            @media (min-width: 1024px) {
                max-width: 40%;
                min-width: 300px;
            }
            @media (min-width: 768px) {
                max-width: 50%;
            }
        }
      
        .splide__pagination {
            bottom: -26px;

            .splide__pagination__page {
                background: #cccccc;
                width: 8px;
                height: 8px;

                &.is-active {
                    background: #502314;
                    transform: scale(1.2);
                }
            }
        }
    }
</style>